import keyMirror from 'keymirror'

export default keyMirror({
  GET_GROUP_ALERT_FIELDS_REQUEST: null,
  GET_GROUP_ALERT_FIELDS_SUCCESS: null,
  GET_GROUP_ALERT_FIELDS_FAILED: null,

  UPDATE_GROUP_ALERT_FIELD_REQUEST: null,
  UPDATE_GROUP_ALERT_FIELD_SUCCESS: null,
  UPDATE_GROUP_ALERT_FIELD_FAILED: null
})
